export default "__VITE_ASSET__DaQjstNc__"